import * as React from 'react';

export type ChatPanelOpenOptions = {
  seedText?: string;
  analysisResultId?: number;
};

type ChatPanelContextValue = {
  openPanel: (opts?: ChatPanelOpenOptions) => void;
  closePanel: () => void;
};

export const ChatPanelContext = React.createContext<ChatPanelContextValue | null>(null);

export const useChatPanel = (): ChatPanelContextValue => {
  const ctx = React.useContext(ChatPanelContext);

  if (!ctx) {
    throw new Error('useChatPanel must be used within ChatPanelContext.Provider');
  }

  return ctx;
};
